import { Center, CircularProgress } from "@chakra-ui/react";

export default function LoadingPage() {
  return (
    <Center h="100vh">
      <CircularProgress isIndeterminate size="100px" />
    </Center>
  );
}
